import { useQueryCountries } from '@hooks/common/useQueryCountries';
import { useQueryTimezones } from '@hooks/common/useQueryTimezones';
import { useQueryOrganisationCategories } from '@hooks/organisation/useQueryOrganisationCategories';
import { useQueryOrganisationRoles } from '@hooks/organisation/useQueryOrganisationRoles';
import { useQueryOrganisationTypes } from '@hooks/organisation/useQueryOrganisationTypes';
import { useQueryRevokedRoles } from '@hooks/organisation/useQueryRevokedRoles';

import { IOrganisationDataParams } from '@interfaces/organisation/organisations';

export const useOrganisationsFormData = (params: IOrganisationDataParams) => {
	const { countries, isLoadingCountries } = useQueryCountries();
	const { timezones, isLoadingTimezones } = useQueryTimezones();
	const { organisationCategories, isLoadingCategories } = useQueryOrganisationCategories();
	const { organisationTypes, isLoadingOrganisationTypes } = useQueryOrganisationTypes();
	const { organisationRoles, isLoadingOrganisationRoles } = useQueryOrganisationRoles(params);
	const { revokedRoles, isLoadingRevokedRoles } = useQueryRevokedRoles(params);

	return {
		countries,
		organisationCategories,
		organisationTypes,
		timezones,
		organisationRoles,
		revokedRoles,
		isLoading: (
			isLoadingCountries
			|| isLoadingCategories
			|| isLoadingTimezones
			|| isLoadingOrganisationRoles
			|| isLoadingRevokedRoles
			|| isLoadingOrganisationTypes
		),
	};
};
